<div class="flex h-full w-full">
  <mat-sidenav-container
    #container
    class="min-w-0 flex-1 !bg-transparent"
    (backdropClick)="navSidenav.close()"
  >
    <mat-sidenav
      #navSidenav
      disableClose
      [class.!-z-10]="(sidebar.isMobile$ | async) === false"
      [fixedInViewport]="true"
      [mode]="(sidebar.state$ | async)?.mode"
      [opened]="(sidebar.state$ | async)?.opened"
      (closedStart)="sidebar.close()"
    >
      <pr-sidebar #sidebarContainer>
        <pr-settings-sidebar
          [expanded]="sidebar.expanded$ | async"
          (widthChange)="container.updateContentMargins()"
        />
      </pr-sidebar>
    </mat-sidenav>

    <mat-sidenav-content class="flex-col overflow-x-hidden bg-transparent">
      <pr-toolbar
        class="fixed inset-x-0 -z-10 mt-0 bg-transparent"
        [class.is-mobile]="sidebar.isMobile$ | async"
        [style.padding-left]="sidebarContainer.width"
        [ngClass]="{
          '!right-[360px]': managementSidebar.opened$ | async
        }"
        [chatCount]="chatCount$ | ngrxPush"
        [notificationsCount]="(notifications$ | async)?.length"
        (notificationsToggle)="notificationsOpen = !notificationsOpen"
      />
      <div class="toolbar-spacer -z-50"></div>
      <div
        fxFlex
        class="overflow-hidden rounded-t-lg bg-[#fafafa] md:mx-1 md:mb-1 md:rounded-b-lg"
      >
        <div class="h-full w-full overflow-scroll">
          <pr-setup-step-banner />
          <router-outlet #router="outlet" />
          @if (!router.isActivated) {
            <pr-settings-splash />
          }
        </div>
      </div>
    </mat-sidenav-content>

    <mat-sidenav
      #notificationsSidenav="matSidenav"
      mode="over"
      position="end"
      class="!bg-[#fafafa]"
      [(opened)]="notificationsOpen"
    >
      <ng-container *ngIf="notifications$ | async as notifications">
        <pr-notifications-sidebar
          [notifications]="notifications"
          (closed)="notificationsSidenav.close()"
        />
      </ng-container>
    </mat-sidenav>
  </mat-sidenav-container>

  @if (managementSidebar.opened$ | async) {
    <div class="h-full w-[360px] shrink-0 bg-white">
      <pt-management-tool-panel (closePanel)="managementSidebar.close()" />
    </div>
  }
</div>

<pr-popup-notifications />
